module.exports = __webpack_public_path__ + "img/banner03-mobile.83147d58.png";